<template>
	<DjCard
		hover
		class="relative flex flex-col min-h-[400px] bg-dj-red bg-left-bottom bg-no-repeat bg-[url('https://res.cloudinary.com/djbs/image/upload/v1652880191/content/DreamJobs/Graphics/bg_bannercard.svg')] cursor-pointer"
		@click="goTo(url)"
	>
		<div class="mt-7 ml-10 mr-16 mb-3">
			<h5 class="text-white/50 text-xl" :class="{ 'mr-36': logo.length > 0 }">{{ subtitle }}</h5>
			<h3 class="text-white text-3xl leading-10">{{ title }}</h3>
		</div>
		<p class="text-white text-base my-auto ml-10 mr-16">{{ description }}</p>
		<div class="mt-3 ml-10 mr-16 mb-9">
			<BaseButton fullwidth type="tertiary" class="text-blue-600">
				{{ cta }}
				<span class="material-icons-outlined pl-2 text-base">arrow_forward</span>
			</BaseButton>
		</div>
		<img
			class="absolute -right-8 bottom-0"
			src="https://res.cloudinary.com/djbs/image/upload/v1652880191/content/DreamJobs/Graphics/pic_bannercard.svg"
			:alt="title"
		/>
		<BaseCloudImage
			v-if="logo.length > 0"
			custom-class="absolute -top-5 right-12 w-dj-80 h-dj-80 border border-dg-grey-light rounded-normal overflow-hidden bg-white flex items-center"
			:public-id="logo"
			:transformation="[{ width: 80, crop: 'scale' }]"
			:alt="subtitle"
		/>
	</DjCard>
</template>

<script lang="ts">
import BaseButton from "~/ui-kit/components/BaseButton.vue";
import BaseCloudImage from "~/ui-kit/components/BaseCloudImage.vue";
import DjCard from "./DjCard.vue";

import { defineComponent } from "vue";

export default defineComponent({
	name: "DjCardCompanyBanner",
	components: {
		DjCard,
		BaseButton,
		BaseCloudImage,
	},
	props: {
		title: {
			type: String,
			default: "light",
		},
		subtitle: {
			type: String,
			default: "",
		},
		description: {
			type: String,
			default: "",
		},
		cta: {
			type: String,
			default: "",
		},
		url: {
			type: String,
			default: "",
		},
		logo: {
			type: String,
			default: "",
		},
	},
	setup() {
		function goTo(url: string) {
			window.open(url.indexOf("://") > -1 ? url : "//" + url, "_blank");
			//window.location.href = url.indexOf('://') > -1 ? url : '//' + url
		}

		return {
			goTo,
		};
	},
});
</script>
